var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00854492H513V341.984H0V-0.00854492Z",
    fill: "#F7CE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00854492H513V85.4951H0V-0.00854492Z",
    fill: "#E32737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 85.4841H513V170.988H0V85.4841Z",
    fill: "#191F6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 256.491H513V341.995H0V256.491Z",
    fill: "#00A04E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.0065918)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMu);
export default __webpack_public_path__ + "static/media/MU.6c69532415e99034e83b97e806df2c07.svg";
export { ForwardRef as ReactComponent };